export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-3xl p-8 md:p-14 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10 pointer-events-none"
            style={{
              backgroundImage: 'radial-gradient(circle at 30% 50%, white 1px, transparent 1px)',
              backgroundSize: '40px 40px',
            }}
          />

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-2 text-background-50/80 text-sm font-medium mb-3 bg-background-50/15 px-4 py-1.5 rounded-full">
                <i className="ri-smartphone-line"></i>
                移动端体验
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-4">
                随时随地，畅快吃瓜
              </h2>
              <p className="text-background-50/85 text-sm md:text-base leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
                爆瓜网移动端完美适配，在手机浏览器中打开即可享受流畅的吃瓜体验。添加到手机桌面，一键直达最新爆料，比App还方便。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 bg-background-50 text-primary-600 hover:bg-background-100 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 即将上线
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 即将上线
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-56 h-[400px] bg-background-50 rounded-3xl border-4 border-background-300 shadow-2xl overflow-hidden">
                <div className="bg-primary-500 h-12 flex items-center justify-center">
                  <span className="text-background-50 font-heading font-bold text-sm">爆瓜网</span>
                </div>
                <div className="p-3 space-y-2">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="bg-background-100 rounded-lg p-2.5 flex gap-2">
                      <div className="w-10 h-10 rounded-lg bg-primary-100 flex-shrink-0 flex items-center justify-center">
                        <i className="ri-fire-line text-primary-500 text-sm"></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="h-2.5 bg-background-300 rounded w-full mb-1.5"></div>
                        <div className="h-2 bg-background-200 rounded w-3/4"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}